import { api, APIResponse } from '@/store/api';
import type { GetAccountsParams, GetAccountsResponse } from '@/types/accounts.types';

export type ActivateUserDto = {
  accountId: string;
  userId: string;
};

export type UserActionResponse = {
  success: boolean;
  message: string;
};

export const accountsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getAccounts: builder.query<GetAccountsResponse, GetAccountsParams>({
      query: (params = {}) => {
        const searchParams = new URLSearchParams();

        if (params.page) searchParams.append('page', params.page.toString());
        if (params.limit) searchParams.append('limit', params.limit.toString());
        if (params.accountId) searchParams.append('accountId', params.accountId);
        if (params.text) searchParams.append('text', params.text);

        return {
          url: `admin/accounts?${searchParams.toString()}`,
          method: 'GET',
        };
      },
      transformResponse: (response: APIResponse<GetAccountsResponse>) => response.data,
      providesTags: ['Accounts'],
    }),

    activateAccount: builder.mutation<void, { accountId: string }>({
      query: ({ accountId }) => ({
        url: `admin/accounts/${accountId}/activate`,
        method: 'PATCH',
      }),
      invalidatesTags: ['Accounts'],
    }),

    deactivateAccount: builder.mutation<void, { accountId: string }>({
      query: ({ accountId }) => ({
        url: `admin/accounts/${accountId}/deactivate`,
        method: 'PATCH',
      }),
      invalidatesTags: ['Accounts'],
    }),

    activateUser: builder.mutation<UserActionResponse, ActivateUserDto>({
      query: (activateUserDto) => ({
        url: 'admin/users/activate',
        method: 'PATCH',
        body: activateUserDto,
      }),
      invalidatesTags: ['Accounts'],
    }),

    deactivateUser: builder.mutation<UserActionResponse, ActivateUserDto>({
      query: (activateUserDto) => ({
        url: 'admin/users/deactivate',
        method: 'PATCH',
        body: activateUserDto,
      }),
      invalidatesTags: ['Accounts'],
    }),
  }),
});

export const {
  useGetAccountsQuery,
  useActivateAccountMutation,
  useDeactivateAccountMutation,
  useActivateUserMutation,
  useDeactivateUserMutation,
} = accountsApi;
